import EnterTournament from '@/apps/EnterTournament'
import React from 'react'

const EnterTournamentBody = (): React.ReactElement => {
  return <EnterTournament />
}

export default EnterTournamentBody
